module.exports = __webpack_public_path__ + "static/media/do.48badacf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/do.svg
// module id = 814
// module chunks = 0